export default class SafariIosAutoplayDrm {
  constructor({ tech } = {}) {
    this._tech = tech;
    this._intervalId = null;
  }

  tech() {
    return this._tech;
  }

  intervalId() {
    return this._intervalId;
  }

  init() {
    this.setAutoplayInterval();
  }

  setAutoplayInterval() {
    this._intervalId = window.setInterval(() => {
      this.autoplayCallback();
    }, 100);
  }

  autoplayCallback() {
    const className = this.tech().el().className();

    if (className.includes('vjs-playing') && className.includes('vjs-waiting') && className.includes('vjs-buffering')) {
      this.triggerPlayAfterMs();
    }
  }

  triggerPlayAfterMs(duration = 300) {
    window.setTimeout(() => {
      const playPromise = this.tech().play();

      if (playPromise !== undefined) {
        playPromise.then(() => {
          window.clearInterval(this.intervalId());
        }).catch(() => {
          window.clearInterval(this.intervalId());
        });
      }
    }, duration);
  }
}
